export const CommonDataActionConst = {
    GET_COMMON_MASTER_DATA_REQ: "GET_COMMON_MASTER_DATA_REQ",
    GET_COMMON_MASTER_DATA_SUCCESS: "GET_COMMON_MASTER_DATA_SUCCESS",
    GET_COMMON_MASTER_DATA_FAIL: "GET_COMMON_MASTER_DATA_FAIL",
}

export const ChangeMaintenenceStep = {
    CHANGE_MAINTENANCE_STEP: "CHANGE_MAINTENANCE_STEP",

}


export const ShiftCheckOutHandlerConst = {
    SHIFT_CHECKOUT: "SHIFT_CHECKOUT",

}



export const SelectedSessionIdActionConst = {
    SELECTED_SESSION_ID: "SELECTED_SESSION_ID",

}




export const selectedSessionIdActionConsy = {
    SELECTED_CHAT_ID: "SELECTED_CHAT_ID",

}


export const selectedCompletedSessionIdActionConsy = {
    SELECTED_COMPLETED_CHAT_ID: "SELECTED_COMPLETED_CHAT_ID",

}






export const BroadcastFlowCreationActionConst = {
    CREATE_BROADCAST_REQ: "CREATE_BROADCAST_REQ",
    CREATE_BROADCAST_SUCC: "CREATE_BROADCAST_SUCC",
    CREATE_BROADCAST_FAIL: "CREATE_BROADCAST_FAIL"

}

export const ChangeBroadcastStepActionConst = {
    CHANGE_BROADCAST_STEP: "CHANGE_BROADCAST_STEP",

}


export const GetCurrentShiftActionConst = {
    GET_CURRENT_SHIFT_REQ: "GET_CURRENT_SHIFT_REQ",
    GET_CURRENT_SHIFT_SUCC: "GET_CURRENT_SHIFT_SUCC",
    GET_CURRENT_SHIFT_FAIL: "GET_CURRENT_SHIFT_FAIL",

}



export const GetAllActiveChatsActionConst = {
  GET_ALL_ACTIVE_CHAT_REQ: "GET_ALL_ACTIVE_CHAT_REQ",
  GET_ALL_ACTIVE_CHAT_SUCC: "GET_ALL_ACTIVE_CHAT_SUCC",
  GET_ALL_ACTIVE_CHAT_FAIL: "GET_ALL_ACTIVE_CHAT_FAIL",

  UPDATE_ACTIVE_CHAT_SESSION: "UPDATE_ACTIVE_CHAT_SESSION",
};
export const GetAllCompletedChatSessionsActionConst = {
    GET_ALL_COMPLETED_CHAT_REQ: "GET_ALL_COMPLETED_CHAT_REQ",
    GET_ALL_COMPLETED_CHAT_SUCC: "GET_ALL_COMPLETED_CHAT_SUCC",
    GET_ALL_COMPLETED_CHAT_FAIL: "GET_ALL_COMPLETED_CHAT_FAIL"

}

